import {useContext, useEffect, useState} from "react";
import Cookies from "js-cookie";
import {AppContext} from "../../../App";

const BallsStates = () => {
  const [submitData, setSubmitData] = useState({
      game: "balls",
      suggestedNumbers: JSON.stringify([]),
      bet: "0.00000000",
      isFirstBet: false,
      firstBetValue: null
    }
  );

  const [settings, setSettings] = useState();
  const [responseData, setResponseData] = useState({
    win: 0,
    manualMode: true
  });

  const [errorData, setErrorData] = useState({
    error: false,
    terminate: false,
  });

  const [winAmount, setWinAmount] = useState(0);

  return {
    submitData,
    setSubmitData,
    settings,
    setSettings,
    responseData,
    setResponseData,
    errorData,
    setErrorData,
    winAmount,
    setWinAmount
  };
};

export default BallsStates;
